module.exports = __webpack_public_path__ + "img/user-p.0d90a4d6.svg";